import styled from 'styled-components'

export const InputStyle = styled('input')`
  width: 100%;
  height: 1.5rem;
  background-color: transparent;
  border: 1px solid rgb(100, 100, 100);
  border-radius: 0.25rem;
  outline: none;
`
